
import { default as esTranslations } from './es.json';

export const es: { [key: string]: string } = {
    ...esTranslations
}

